var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilePlus = function SvgIconFilePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.25a1 1 0 0 1 1-1H11V12a1 1 0 1 1 2 0v1.25h1.25a1 1 0 1 1 0 2H13v1.25a1 1 0 1 1-2 0v-1.25H9.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 20.25A1.75 1.75 0 0 1 18.75 22H5.25a1.75 1.75 0 0 1-1.75-1.75V3.75A1.75 1.75 0 0 1 5.25 2h9a1 1 0 0 1 .707.293l5.25 5.25a1 1 0 0 1 .293.707zM5.5 20V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20zM17.46 7.625h-2.585V5.039z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFilePlus;